export const sanitize = value => value?.trim()?.replace(/\s+/g, ' ');

export const required = (value, fieldName) => {
  if (typeof value === 'undefined') {
    throw new Error(`${fieldName} is not defined`);
  }

  return value;
};
